import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;

export function loadCommunityConfig() {
  if (cache) return Promise.resolve(cache);
  if (!pending) pending = api.get("/communities/config").then((r) => { cache = r.data; return cache; }).catch(() => ({}));
  return pending;
}

// Contagens de membros ficam ocultas até a plataforma ter 1000 utilizadores registados (decidido no backend); a contagem interna continua.
export function useShowMemberCounts() {
  const [show, setShow] = useState(cache ? !!cache.show_member_counts : false);
  useEffect(() => { loadCommunityConfig().then((c) => setShow(!!c.show_member_counts)); }, []);
  return show;
}
